import React, { Component } from "react"
import OfficeCardBasic from "components/offices/layout/OfficeCardBasic"

export class OfficePageBasic extends Component {
    render() { return (<OfficeCardBasic />) }
}
